export async function consumeLimitedAction(actionKey: string, actionLabel: string) {
  void actionKey;
  void actionLabel;

  return {
    allowed: true,
    remaining: null,
    used: 0,
    requires_kyc: false,
  };
}
